import React, { useEffect, useRef, useState } from 'react';
import { FlagDown, FlagUp, GoBack } from '../../icon/Icon';
import {
	CodeSelector,
	CodeSelectorList,
	FlagLabel,
	FlagsMenuItem,
	FlexRow,
	PhoneCodeGoBack,
} from '../../components/ui/Content';
import { Body1, FormTitle } from '../../components/Font';
import { useOnClickOutside } from '../../hooks/useClickOutside';
import getUnicodeFlagIcon from 'country-flag-icons/unicode';
import styled from 'styled-components/macro';
import { useWindowResize } from '../../hooks/useWindowSize';
import { useTranslation } from 'react-i18next';

export interface InputSearchProps {
	value?: string;
	onChange(value?: string): void;
	options: { value?: string; label: string }[];
}

export const InputPhone = ({ value, onChange, options }: InputSearchProps): React.ReactElement => {
	const { isMobile } = useWindowResize();
	const { t } = useTranslation();
	const [search, setSearch] = useState('');
	const [opened, setOpened] = useState(false);
	const ref = useRef<HTMLDivElement>(null);
	useOnClickOutside(ref, () => setOpened(false));

	useEffect(() => {
		if (opened) {
			setSearch('');
			const input = document.getElementById('HiddenInput') as HTMLInputElement;
			if (input) {
				input.focus();
			}
		}
	}, [opened]);

	const flagsList = options
		.filter(i => i.label.toLowerCase().includes(search.toLowerCase()))
		.map((flag, index) => (
			<FlagsMenuItem
				key={index}
				onClick={() => {
					onChange(flag.value);
					setOpened(false);
				}}
			>
				<Body1>{getUnicodeFlagIcon(flag.value || 'ZZ')}</Body1>
				<Body1
					title={flag.label}
					style={{
						whiteSpace: 'nowrap',
						overflow: 'hidden',
						width: '95%',
						textOverflow: 'ellipsis',
						textAlign: 'start',
					}}
				>
					{flag.label}
				</Body1>
			</FlagsMenuItem>
		));

	return (
		<InputPhoneContainer>
			<FlagLabel>
				<FlexRow style={{ gap: '9px' }}>
					<FlexRow
						onClick={() => setOpened(prev => !prev)}
						style={{ alignItems: 'center', gap: '8px', cursor: 'pointer' }}
					>
						{getUnicodeFlagIcon(value || 'ZZ')}
						{opened ? <FlagUp /> : <FlagDown />}
					</FlexRow>
					{/*<Body1 color={Theme.color.primary} className={'phone-code'}>{options.find(i => i.value === value)?.label}</Body1>*/}
				</FlexRow>
			</FlagLabel>
			{opened && (
				<CodeSelector ref={ref}>
					<HiddenInput
						onKeyDown={e => {
							const optionsList = options.filter(i => i.label.toLowerCase().includes(search.toLowerCase()));
							if (e.code === 'Enter' && optionsList.length === 1) {
								setOpened(false);
								if (optionsList[0]) {
									onChange(optionsList[0].value);
								}
							}
						}}
						id={'HiddenInput'}
						value={search}
						onChange={e => setSearch(e.currentTarget.value)}
					/>
					{isMobile && (
						<FlexRow>
							<PhoneCodeGoBack onClick={() => setOpened(false)}>
								<GoBack />
							</PhoneCodeGoBack>
							<FormTitle>Выберите страну</FormTitle>
						</FlexRow>
					)}
					<CodeSelectorList>
						{flagsList.length > 0 ? (
							flagsList
						) : (
							<Body1 style={{ margin: '10px', whiteSpace: 'nowrap' }}>{t('auth.nothingFound')}</Body1>
						)}
					</CodeSelectorList>
				</CodeSelector>
			)}
		</InputPhoneContainer>
	);
};

const InputPhoneContainer = styled.div`
	display: flex;
	position: absolute;
	left: 10px;
`;
const HiddenInput = styled.input`
	position: absolute;
	width: 0 !important;
	height: 0 !important;
	border: none !important;

	:focus,
	:active {
		border: none !important;
	}
`;
